<div class="product-chart-button-div">
	<a
		class="product-chart-button"
		[ngClass]="{
			'product-chart-button-selected': daysButton,
			'product-chart-button-selected-disabled': applyNodata
		}"
		style="padding: 0 0.65rem"
		(click)="changeGraphData('days')"
		><div>days</div></a
	>
	<a
		class="product-chart-button"
		[ngClass]="{ 'product-chart-button-selected': weeksButton, 'product-chart-button-disabled': applyNodata }"
		style="padding: 0 0.4rem"
		(click)="changeGraphData('weeks')"
		><div>weeks</div></a
	>
	<a
		class="product-chart-button"
		[ngClass]="{ 'product-chart-button-selected': monthsButton, 'product-chart-button-disabled': applyNodata }"
		style="padding: 0 0.16rem"
		(click)="changeGraphData('months')"
		><div>months</div></a
	>
</div>
